export default "__VITE_ASSET__DxDZ5XhY__"